





































































































































import { Component } from "vue-property-decorator";
import { PaginationModel, VHeaders } from "@/models/pagedlistmodel";
import { Base } from "@/components/common/base";
import { vehicleInventoryService, attachmentService, storeService } from "@/shared";
import { Utils } from "@/helper/utils";
import { getSoldVehicleHeaders } from "./listHeaders";
import { IDialogOption } from "@/models/dialog";
import { TenantInfo } from "@/models/inventory/vehiclerevivestep";
import { FileUploadDataViewModel } from "@/Alynk.dtos";
import { FileHelper as _file } from "@/helper/file.helper";
import * as marked from 'marked';
import { IFileUploaderOption } from "@/models/fileUploader";
import { NotificationType } from "@/helper/enum";

@Component({
  props: ["methodName", "progress"],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    compiledMarkdown: {
      get() {
        return marked(this.vehicleDescription);
      }
    },
  },
  components: {
    Grid: () => import("@/components/common/app.grid.vue"),
    AppDialog: () => import("@/components/common/app.dialog.vue"),
    FileUpload: () => import('@/components/common//app.fileupload.v2.vue')
  },
})
export default class SoldVehicleInvoiceListPage extends Base {
  public soldVehicleItems: any[] = [];
  public headers: VHeaders[] = [];
  public loading: boolean = false;
  public actions: any[] = [];
  public pagination = new PaginationModel("createdAt", true);
  public modelFilter: any = "";
  public currentStoreId: any = "";
  public tenantInfo: TenantInfo = {
    tenantId: 0,
    enterpriseId: 0,
    storeId: 0,
  };
  public FileUri: string = "";
  public OcrToken: string = "";
  public dragging: boolean = false;
  public dragclass: string = "";
  public files: any = [];
  public attachmentFiles: FileUploadDataViewModel[] = [];
  public disableUploadButton: boolean = false;
  public invoiceIdToDelete = "";
  public isStockNumber: boolean = false;
  public isShowAllRecord: boolean = true;
  public vehicleDescription: string = '';
  public isVehicleDescriptionLoading: boolean = false;
  public isButlerDefaultOcrProvider: boolean = false;
  public uploadBtnLoading: boolean = false;
  public fileUploderRef: string = "soldVehicleInvoiceList";

  public filtersItems: any[] = [
    { value: "Vin", text: "Vin" },
    { value: "StockNumber", text: "Stock Number" },
  ];

  constructor() {
    super();
  }
  public fileDialog: IFileUploaderOption = {
    ref: this.fileUploderRef,
    inputFiles: this.files,
    multiple: true,
    drop: true,
    extensions: ['.pdf']
  };

  public syncAttachmentFiles(inputFilesToSync: any[], outputFilesToSync: FileUploadDataViewModel[]) {
    this.files = inputFilesToSync;
    this.attachmentFiles = outputFilesToSync;
  }

  public fileUploadLoader(val: boolean) {
    this.uploadBtnLoading = val;
  }

  public dialogVehicleInvoiceResubmit: IDialogOption = {
    width: 400,
    title: "Confirm?",
    model: false,
    loading: false,
    action: { color: "success", icon: "fas fa-check", text: "Submit" },
    onAction: (): void => {
      this.submitVehicleInvoiceOcrDetails();
    },
  };

  public deleteDialog: IDialogOption = {
    width: 400,
    title: "Confirm?",
    model: false,
    action: {
      color: "success",
      icon: "fas fa-check",
      text: "Agree",
      disable: false,
    },
    onAction: (): void => {
      this.deleteInvoice();
    },
  };

  public setActions() {
    this.actions = [
      // {
      //   type: "button",
      //   icon: "fas fa-car",
      //   title: 'Vehicle Description',
      //   loading: false,
      //   action: (model: any, action: any) => {
      //     this.vehicleDescription = '';
      //     this.getVehicleDescription(model);
      //   },
      // },
      {
        type: "button",
        icon: "fas fa-eye",
        title: this.$parent.$t(
          "scannedInvoices.gridHeaders.gridAction.view"
        ) as string,
        loading: false,
        action: (model: any, action: any) => {
          this.openAttachment(model.fullFileUri, action);
        },
      },
      {
        type: "button",
        icon: "fas fa-receipt",
        title: "Resubmit",
        visible: (model: any) => {
          if (model.stockNumber != undefined && model.stockNumber != "")
            return false;
          if (model.dmsStatus == "success") return false;
          return true;
        },
        action: (model: any) => {
          this.dialogVehicleInvoiceResubmit.model = true;
          this.tenantInfo = {
            tenantId: model.tenantId,
            enterpriseId: model.enterpriseId,
            storeId: model.storeId,
          };
          this.FileUri = model.fileUri;
          this.OcrToken = model.ocrToken;
        },
      },
      {
        type: 'button',
        icon: 'fa fa-file-text',
        title: "Re Map Invoice",
        color: 'primary',
        loading: false,
        visible: (model: any) => {
          if (model.documentId && !model.stockNumber && this.isButlerDefaultOcrProvider) {
            return true;
          } else {
            return false;
          }
        },
        action: (model: any, action: any) => {
          this.$router.push({
            name: "app.vehicleinventory.document",
            params: {
              uri: model.fileUri,
              documentId: model.documentId,
              impiraUid: model.ocrToken
            }
          });
        },
      },
      {
        type: "button",
        icon: "fas fa-trash-alt",
        title: "Delete",
        color: "error",
        action: (model: any) => {
          this.confirmDelete(model);
        },
      },
    ];
  }

  public mounted(): void {
    // activating tab
    this.$root.$emit("sidebar.layout.vue", "soldvehicleinvoice");

    this.setActions();
    this.setHeaders();
    this.getStores();
    this.getSoldVehicleList();
  }
  public async getStores() {

    this.currentStoreId = this.userSession.storeId;
    const storeData = await storeService.getStore(Number(this.currentStoreId));
    if (storeData && storeData.storeJson) {
      this.isButlerDefaultOcrProvider = storeData.storeJson.defaultOcrProvider == "Butler";
    }
  }

  public setHeaders() {
    this.headers = getSoldVehicleHeaders();
  }

  public async getSoldVehicleList(): Promise<void> {
    try {
      this.loading = true;
      const queryStringObj = Object.assign({}, this.pagination);
      Utils.validateAndUpdateRoute(queryStringObj);
      const result = await vehicleInventoryService.getSoldVehicleInvoices(
        this.pagination,
        this.modelFilter,
        this.isShowAllRecord
      );
      this.soldVehicleItems = result.results;
      this.pagination.totalItems = result.total;
      this.setHeaders();
    } finally {
      this.loading = false;
    }
  }

  public updatePaging(paging: any): void {
    this.pagination = paging;
    this.getSoldVehicleList();
  }

  public async openAttachment(uri: string, action: any): Promise<void> {
    if (!uri) {
      this.showAlert(false, this.$t("epicorAttachments.UriNotFound"));
      return;
    }

    try {
      action.loading = true;
      await attachmentService.viewAttachmentByUriAsync(uri);
    } finally {
      action.loading = false;
    }
  }

  public searchSoldVehicleList() {
    if (this.modelFilter == "") {
      this.showAlert(false, "Please Select Filter By");
      return;
    }

    if (this.pagination.search == "") {
      this.showAlert(false, "Please Enter a Value to Search");
      return;
    }
    this.pagination.page = 1;
    this.getSoldVehicleList();
  }

  public resetAttachmentsReport() {
    this.modelFilter = "";
    this.pagination.search = "";
    this.getSoldVehicleList();
  }

  public async submitVehicleInvoiceOcrDetails(): Promise<void> {
    try {
      this.dialogVehicleInvoiceResubmit.loading = true;
      const response =
        await vehicleInventoryService.saveVehicleInvoiceOcrDetails(
          this.tenantInfo.tenantId,
          this.tenantInfo.enterpriseId,
          this.tenantInfo.storeId,
          this.FileUri,
          this.OcrToken
        );

      if (response.success) {
        this.showAlert(true, "Vehicle posted to DMS successfully.");
        this.getSoldVehicleList();
      } else {
        if (response.message) {
          this.showAlert(false, response.message);
        } else {
          this.showAlert(false, "An error has occurred.");
        }
      }
    } finally {
      this.tenantInfo = {
        tenantId: 0,
        enterpriseId: 0,
        storeId: 0,
      };
      this.FileUri = "";
      this.OcrToken = "";
      this.dialogVehicleInvoiceResubmit.loading = false;
      this.dialogVehicleInvoiceResubmit.model = false;
    }
  }


  public confirmUpload(): void {
    if (this.attachmentFiles.length == 0) {
      this.showAlert(
        false,
        this.$t("vehicleReviveAttachment.alertSelectFileForUpload")
      );
      return;
    }
    this.uploadDialog.model = true;
  }

  public uploadDialog: IDialogOption = {
    width: 400,
    title: "Confirm",
    model: false,
    action: { color: "success", icon: "fas fa-check", text: "Agree" },
    loading: false,
    onAction: (): void => {
      this.UploadAttachment();
    },
  };

  public vehicleDescriptionDialog: IDialogOption = {
    width: 1000,
    title: "Vehicle Description",
    model: false,
    loading: false,
  };

  public async UploadAttachment() {

    if (this.attachmentFiles.length > 0) {
      try {
        this.uploadDialog.loading = true;
        this.uploadBtnLoading = true;

        var message = await vehicleInventoryService.manualUploadVehicleInvoice(
          this.attachmentFiles
        );

        if(message?.responseStatus?.message != undefined && message?.responseStatus?.message != "")
        {
          this.showNotification(NotificationType.Warning, message?.responseStatus?.message);
          return;
        }

        this.showAlert(
          true,
          "Invoice has been successfully uploaded and queued for ocr, please check after some time"
        );

        this.files = [];
      } finally {
        this.uploadDialog.loading = false;
        this.uploadDialog.model = false;
        this.uploadBtnLoading = false;
        this.attachmentFiles = [];
        this.files = [];
        this.$root.$emit('resetFileList', this.fileUploderRef);

      }
    }

  }

  public confirmDelete(item: any): void {
    this.deleteDialog.model = true;
    this.invoiceIdToDelete = item.id;
    this.isStockNumber = item.stockNumber ? true : false;
  }

  public async deleteInvoice(): Promise<void> {
    try {
      this.deleteDialog.action.disable = true;
      const response = await vehicleInventoryService.deleteVehicleInvoice(
        this.invoiceIdToDelete
      );
      if (response.success) {
        this.showAlert(true, "Invoice delete successfully.");
        this.getSoldVehicleList();
      } else {
        this.showAlert(false, "An error has occurred.");
      }
      this.deleteDialog.action.disable = false;
    } catch (e) {
      console.log(e);
    } finally {
      this.invoiceIdToDelete = "";
      this.isStockNumber = false;
      this.deleteDialog.model = false;
      this.deleteDialog.action.disable = false;
    }
  }

  public toggleAsignToSoldVehicleList() {
    this.getSoldVehicleList();
  }

  public getOptionalFieldValue(props: any, description: string): string {
    const fields = props?.optionalFields;
    if (!Array.isArray(fields)) return '';

    // const match = fields.find(f => f.description === description);
      const match = fields.find(f => 
    f?.description?.toLowerCase() === description?.toLowerCase()
  );
    return match?.value || '';
  }


  // public async getVehicleDescription(model) {
  //   try {
  //     this.vehicleDescriptionDialog.model = true;
  //     this.vehicleDescriptionDialog.loading = true;
  //     this.isVehicleDescriptionLoading = true;
  //     var response = await vehicleInventoryService.getVehicleDescription(
  //       model.vin, model.storeId, model.ocrToken
  //     );
  //     if (response.success) {
  //       this.vehicleDescription = response.message;
  //     } else {
  //       this.vehicleDescriptionDialog.model = false;
  //     }
  //   }
  //   catch (ex) {
  //     console.log(ex);
  //     this.vehicleDescriptionDialog.model = false;
  //   }
  //   finally {
  //     this.vehicleDescriptionDialog.loading = false;
  //     this.isVehicleDescriptionLoading = false;
  //   }
  // }
}
